/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum NonLabExamsListAliases {
  AUTOC_NON_EXAM_TYPE = 'autoc-non-exam-type',
  AUTOCOMPLETE_EXAM_TYPES = 'autocomplete-exam-types',
  AUTOCOMPLETE_STATUSES = 'autocomplete-statuses',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DATE_PICKER_END_DATE = 'date-picker-end-date',
  DATE_PICKER_START_DATE = 'date-picker-start-date',
  DECK_NON_LAB_EXAMS = 'deck-non-lab-exams',
  FETCH_EXAM_TYPE = 'fetch-exam-type',
  FETCH_NON_LAB_EXAMS = 'fetch-non-lab-exams',
  FIELD_EXAM_STATUS = 'field-exam-status',
  FIELD_EXAM_TYPE = 'field-exam-type',
  FIELD_NON_EXAM_TYPE = 'field-non-exam-type',
  FILTER_FIELD_DATE_END = 'filter-field-date-end',
  FILTER_FIELD_DATE_START = 'filter-field-date-start',
  FILTER_NON_LAB_EXAMS = 'filter-non-lab-exams',
  FILTERED_LIST_NON_LAB_EXAMS = 'filtered-list-non-lab-exams',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  LAYOUT_NON_LAB_EXAMS = 'layout-non-lab-exams',
  MAPPER_EXAM_TYPES = 'mapper-exam-types',
  MAPPER_NON_EXAM_TYPE = 'mapper-non-exam-type',
  MAPPER_STATUSES = 'mapper-statuses',
  MEDIA_QUERY_NON_LAB_EXAMS = 'media-query-non-lab-exams',
  NON_LAB_EXAM_CARD = 'non-lab-exam-card',
  TEXT_0 = 'text-0',
  TEXT_EXAM_TYPES = 'text-exam-types',
  TEXT_NON_EXAM_TYPE = 'text-non-exam-type',
}
export { NonLabExamsListAliases };
